/* ocbon-adv.js — Advertorial / Listicle LP interactions */
(function () {
  'use strict';

  /* ── FAQ Accordion ────────────────────────────────────────────────── */
  function initFaq() {
    var items = document.querySelectorAll('.adv-faq__item');
    items.forEach(function (item) {
      var btn = item.querySelector('.adv-faq__question');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        // Close all
        items.forEach(function (i) { i.classList.remove('is-open'); });
        // Toggle clicked
        if (!isOpen) item.classList.add('is-open');
      });
    });
  }

  /* ── Testimonial Carousel ──────────────────────────────────────────── */
  function initCarousel() {
    var track = document.querySelector('.adv-testimonials__track');
    var prevBtn = document.querySelector('.adv-carousel-prev');
    var nextBtn = document.querySelector('.adv-carousel-next');
    var dots = document.querySelectorAll('.adv-carousel-dot');

    if (!track || !prevBtn || !nextBtn) return;

    var cards = track.querySelectorAll('.adv-testimonials__card');
    var perPage = window.innerWidth < 600 ? 1 : 2;
    var total = cards.length;
    var pages = Math.ceil(total / perPage);
    var current = 0;

    function goTo(page) {
      current = Math.max(0, Math.min(pages - 1, page));
      var offset = current * perPage;
      var cardWidth = cards[0].getBoundingClientRect().width;
      var gap = 20;
      track.style.transform = 'translateX(-' + (offset * (cardWidth + gap)) + 'px)';
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === current);
      });
    }

    prevBtn.addEventListener('click', function () { goTo(current - 1); });
    nextBtn.addEventListener('click', function () { goTo(current + 1); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.getAttribute('data-index'), 10));
      });
    });

    // Recalculate on resize
    window.addEventListener('resize', function () {
      perPage = window.innerWidth < 600 ? 1 : 2;
      pages = Math.ceil(total / perPage);
      goTo(0);
    });
  }

  /* ── Mobile Sticky Bar ────────────────────────────────────────────── */
  function initStickyBar() {
    var bar = document.querySelector('.adv-sticky-bar');
    var hero = document.querySelector('.adv-hero');

    if (!bar) return;

    if (hero && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            bar.classList.add('is-visible');
          } else {
            bar.classList.remove('is-visible');
          }
        });
      }, { threshold: 0 });
      observer.observe(hero);
    } else {
      // Fallback: show after 300px scroll
      window.addEventListener('scroll', function () {
        if (window.scrollY > 300) {
          bar.classList.add('is-visible');
        } else {
          bar.classList.remove('is-visible');
        }
      }, { passive: true });
    }

    // Smooth scroll to product section
    var stickyBtn = bar.querySelector('.adv-sticky-bar__btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function (e) {
        var target = document.querySelector('#adv-product');
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }
  }

  /* ── Timeline Scroll Highlighting ────────────────────────────────── */
  function initTimeline() {
    var items = document.querySelectorAll('.adv-timeline__item');
    if (!items.length || !('IntersectionObserver' in window)) return;

    var tl = document.querySelector('.adv-timeline');
    if (!tl) return;

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // Animate items in sequence
          items.forEach(function (item, i) {
            setTimeout(function () {
              item.classList.add('is-active');
            }, i * 200);
          });
          obs.unobserve(tl);
        }
      });
    }, { threshold: 0.3 });

    obs.observe(tl);
    // Reset initially (only first item active by default)
    items.forEach(function (item, i) {
      if (i > 0) item.classList.remove('is-active');
    });
  }

  /* ── Smooth anchor scrolling ─────────────────────────────────────── */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var hash = link.getAttribute('href');
        var target = document.querySelector(hash);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  /* ── Init ─────────────────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    initFaq();
    initCarousel();
    initStickyBar();
    initTimeline();
    initSmoothScroll();
  });
})();
